import { BaseController } from '~/utils/base-controller';
import { WidgetSettingsModal } from './modal/widget-settings';

export default class WidgetWrapper extends BaseController {
	// bindings
	/** @type {Dashboard.BaseWidget | undefined} */
	widget;

	/* @ngInject */
	/**
	 * @param {import('angular').auto.IInjectorService} $injector
	 */
	constructor(
		$injector,
	) {
		super($injector);

		/**
			*
			* @param {string} [kid]
			*/
		// eslint-disable-next-line no-unused-vars
		this.onLockWidget = kid => {};
	}

	/**
		* @param {string} kid
		*/
	lockWidget(kid) {
		this.onLockWidget(kid);
	}

	refreshWidget() {}

	isAdmin() {
		return this.$rootScope.context?.profil?.admin ?? 0;
	}

	isKtableWidget() {
		return this.widget?.type === 'ktable' ?? false;
	}

	openWidgetNode() {
		const kid = this.widget?.kid;

		if (kid) {
			window.open(`/form/${kid}`, '_blank');
		}
	}

	openQuery() {
		/** @type {Dashboard.KTableWidgetOptions | undefined} */
		const w = this.widget;
		if (w) {
			window.open(`/query?kid=${w.queryNode.kid}`, '_blank');
		}
	}

	async editWidget() {
		const modal = new WidgetSettingsModal(this.$injector);

		try {
			const answer = await modal.open(this.widget);
			if (answer) {
				try {
					const result = await this.api.settings.set({
						id: 'settings',
						node_kid: this.widget.kid,
						kjson: JSON.stringify(answer),
					});

					this.widget.options = {
						kid: result.kid,
						data: answer,
					};

					this.refreshWidget();

					this.Notification.success({
						title: 'Configuration enregistrée',
						message: 'La configuration utilisateur du widget a été enregistrée avec succès.',
					});
				}
				catch (error) {
					this.Notification.success({
						title: 'Echec de l\'enregistrement',
						message: 'Une erreur est survenue lors de l\'enregistrement de la configuration utilisateur du widget.',
					});
					console.error(error);
				}
			}
		}
		catch (error) {
			console.error(error);
		}
	}
}
